module.exports = {
    DAILY_DEALS: 'DAILY_DEALS',
    GROUP_DEALS: 'GROUP_DEALS',
    MENU: 'MENU'
}